module.exports = __webpack_public_path__ + "img/plan-m.608328df.png";